import { getDomainFromEmail } from '../utils/getDomainFromEmail';
export const GMAIL_LINK = 'https://mail.google.com/mail/';
export const YAHOO_LINK = 'https://mail.yahoo.com';
export let EmailClient;

(function (EmailClient) {
  EmailClient["Gmail"] = "gmail";
  EmailClient["Yahoo"] = "yahoo";
})(EmailClient || (EmailClient = {}));

export const emailClientFromDomain = email => {
  const domain = getDomainFromEmail(email, true);

  if (domain) {
    if (domain.includes('gmail.com')) {
      return EmailClient.Gmail;
    }

    if (domain.includes('yahoo.com')) {
      return EmailClient.Yahoo;
    }
  }

  return null;
};